module.exports = __webpack_public_path__ + "static/media/riskareas.cf3dda2b.svg";